import React, { useEffect, useState } from 'react';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from '../../Analytics/Charts/CustomHighChart';

const ChartPowerFlowForecast = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const drawChart = async (_data) => {
    const {
      Base_Demand_Kw,
      Battery_Storage_Kwh,
      NetDemand_Kw,
      PV_Generation_Kw,
      hour_of_day,
    } = _data;

    if (_data.length === 0) return;

    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'chrtContainer',
        height: '500px',
        type: 'line',
      },
      xAxis: {
        type: 'category',
        categories: Object.values(hour_of_day),
        title: {
          text: 'Half Hours',
        },
      },
      yAxis: [
        {
          title: {
            text: 'Power Kw',
          },
        },
      ],
      series: [
        {
          name: 'Grid_Kw',
          color: constants.colorObjLCForecast.grid,
          data: Object.values(NetDemand_Kw),
          legendIndex: 1,
        },
        {
          name: 'Battery_Kw',
          color: constants.colorObjLCForecast.battery,
          data: Object.values(Battery_Storage_Kwh),
        },
        {
          name: 'Site_Kw',
          color: constants.colorObjLCForecast.site,
          data: Object.values(Base_Demand_Kw),
        },
        {
          name: 'Solar_Kw',
          color: constants.colorObjLCForecast.solar,
          data: Object.values(PV_Generation_Kw),
        },
      ],
      plotOptions: {
        line: {
          marker: {
            enabled: false,
          },
        },
      },
    });
    setLoading(false);
    setData(chart);
  };

  useEffect(() => {
    drawChart(props.data);
  }, [props.data]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default ChartPowerFlowForecast;
